import { render, staticRenderFns } from "./ProjectMemberModal.vue?vue&type=template&id=4677ccbe&"
import script from "./ProjectMemberModal.vue?vue&type=script&lang=ts&"
export * from "./ProjectMemberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports